// src/constants/assets.ts
export const ASSETS = {
    images: {
      orbitalPattern: '/assets/images/orbital-pattern.png',
      geometricArrow: '/assets/images/geometric-arrow.png',
      chibatoreOptions: '/assets/images/chibatore-options.png',
      chibatoreDiagram: '/assets/images/chiba.png',
      chibatoreDiagramHighlight: '/assets/images/chiba-highlight.png',
      mobileMock: '/assets/images/mobile-mock.png',
      morphingDemo: '/assets/images/morphing-demo.gif',
      aiArchitecture: '/assets/images/ai-architecture.png',
      architectureDiagram: '/assets/images/architecture-diagram.png',
      evolutionSketch1: '/assets/images/idea-evolution/IMG_3817.webp',
      evolutionSketch2: '/assets/images/idea-evolution/IMG_3818.webp',
      evolutionState1: '/assets/images/idea-evolution/IMG_3819.webp',
      evolutionState2: '/assets/images/idea-evolution/IMG_3820.webp'
    },
    videos: {
      featureDemo: '/assets/videos/feature-demo.mp4',
      cardsDemo: '/assets/videos/cards-demo.mp4'
    }
  } as const